module.exports = __webpack_public_path__ + "static/media/banner-left-img.32eb1174.png";